import {CrudService} from '../services/';

export const fetchPeopleCourses = (params = {}) => {
    return CrudService._get({
        url: 'v1/people-courses',
        params,
    });
};

export const fetchCourses = (params = {}) => {
    return CrudService._get({
        url: 'v1/courses',
        params,
    });
};

export const postPeopleCourses = (data) => {
    return CrudService._post({
        url: 'v1/people-courses/add',
        data
    });
};

export const putPeopleCourse = (data) => {
    return CrudService._put({
        url: `v1/people-courses/edit/${data.id}`,
        data
    });
};

export const getPeopleCourse = ({id, uuid}) => {
    return CrudService._get({
        url: `v1/people-courses/view/${id}/${uuid}`,
    });
};

export const postCourses = (data) => {
    return CrudService._post({
        url: `v1/courses/add`,
        data
    });
};

export const getCourses = (id) => {
    return CrudService._post({
        url: `v1/courses/view/${id}`
    });
};

export const putCourses = (data) => {
    return CrudService._put({
        url: `v1/courses/edit/${data.id}`,
        data
    });
};

export const putCourseDeleteCover = (id) => {
    return CrudService._post({
        url: `v1/courses/delete-cover/${id}`
    });
};

export const postCoursesCover = (data) => {
    const id = data.get('id');

    return CrudService._post({
        url: `v1/courses/edit/${id}`,
        data
    });
};

export const deleteCourses = (id) => {
    return CrudService._delete({
        url: `v1/courses/delete/${id}`,
    });
};

export const getFreight = (params) => {
    return CrudService._post({
        url: `/status/frete`,
        data: params
    });
};

export const checkCoupon = (data) => {
    return CrudService._post({
        url: 'v1/coupons/check',
        data
    });
};